import { useCoverImagePickerModal } from "@circle-react/components/QuickPostV3/CoverImagePickerModal";
import type { PostFormValues } from "@circle-react/components/QuickPostV3/data/types";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

export const useCoverPicker = () => {
  const { setValue } = useFormContext<PostFormValues>();
  const coverImagePickerModal = useCoverImagePickerModal();

  const handleCoverAttach = useCallback(
    (signedId: string) => {
      setValue("cover_image", signedId, {
        shouldDirty: true,
        shouldValidate: true,
      });
    },
    [setValue],
  );

  const openCoverPicker = useCallback(() => {
    void coverImagePickerModal.show({ onAttach: handleCoverAttach });
  }, [coverImagePickerModal, handleCoverAttach]);

  return { openCoverPicker };
};
